import { SITE_NAME, SITE_URL } from '@/constants/siteSeo'

export function buildFaqPageSchema(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(item => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a
      }
    }))
  }
}

export function buildPricingItemListSchema(packages) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: `${SITE_NAME} 科研点数套餐`,
    itemListElement: packages.map((pkg, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Product',
        name: pkg.name,
        description: pkg.description,
        brand: { '@type': 'Brand', name: SITE_NAME },
        offers: {
          '@type': 'Offer',
          url: `${SITE_URL}/pricing`,
          priceCurrency: 'CNY',
          price: pkg.price,
          availability: 'https://schema.org/InStock',
          description: `${Number(pkg.quotaAmount).toLocaleString()} 字符科研点数`
        }
      }
    }))
  }
}

export const MARKETING_COMPLIANCE = {
  title: '适用边界与合规说明',
  paragraphs: [
    '笔芯科研是面向科研写作者的学术文档优化工具，提供语义级改写、检测体系策略适配与语言润色能力，不替代作者的学术判断与原创责任。',
    '请在遵守学校、培养单位与期刊投稿规范的前提下使用本平台；禁止利用本服务从事代写、抄袭或其他学术不端行为。处理结果因原文、学科与检测版本而异，提交定稿前请自行复检并保留修改记录。',
    '我们不对任何检测机构或院校的判定结果作“包过”承诺；平台文案中的效果描述仅表示常见场景下的优化方向，不构成法律或学术担保。'
  ],
  bullets: [
    '工具定位：辅助优化表达与自查，非代写服务',
    '数据用途：仅完成您提交的任务，不用于对外公开或模型训练',
    '建议流程：试改 → 复检 → 全文处理 → 再次官方检测'
  ]
}
